var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  AmenityTag: () => AmenityTag,
  BadgeKind: () => BadgeKind,
  BathroomKind: () => BathroomKind,
  BookKind: () => BookKind,
  BookingFlexibility: () => BookingFlexibility,
  BookingIdVerificationStatus: () => BookingIdVerificationStatus,
  BookingItemSummaryKind: () => BookingItemSummaryKind,
  BookingPaymentBalanceStatus: () => BookingPaymentBalanceStatus,
  BookingStatus: () => BookingStatus,
  BudgetRange: () => BudgetRange,
  CancellationPolicyType: () => CancellationPolicyType,
  CashOrFinanced: () => CashOrFinanced,
  ChannelCancellationKind: () => ChannelCancellationKind,
  ChannelCancellationStatus: () => ChannelCancellationStatus,
  ClientType: () => ClientType,
  CollectionKind: () => CollectionKind,
  CommunicationCategoryKey: () => CommunicationCategoryKey,
  ConfirmationStep: () => ConfirmationStep,
  ContactKind: () => ContactKind,
  ContractSignStatus: () => ContractSignStatus,
  ContractStatus: () => ContractStatus,
  CountryStatesChoice: () => CountryStatesChoice,
  CreditCardType: () => CreditCardType,
  CreditsReason: () => CreditsReason,
  CreditsSourceKind: () => CreditsSourceKind,
  DiscountBadgeIcon: () => DiscountBadgeIcon,
  DocumentKind: () => DocumentKind,
  EmailContactAnswerType: () => EmailContactAnswerType,
  FeeKind: () => FeeKind,
  FridgePackageOrderStatus: () => FridgePackageOrderStatus,
  GuestInvitationStatus: () => GuestInvitationStatus,
  GuestType: () => GuestType,
  HomeDateOccupancyStatus: () => HomeDateOccupancyStatus,
  HomeQuerySorting: () => HomeQuerySorting,
  HowDidYouHearAboutUs: () => HowDidYouHearAboutUs,
  InputPaymentMode: () => InputPaymentMode,
  LeadSource: () => LeadSource,
  LicensedStates: () => LicensedStates,
  LinkStatus: () => LinkStatus,
  ListingKind: () => ListingKind,
  ListingPropertyType: () => ListingPropertyType,
  ListingQuerySorting: () => ListingQuerySorting,
  OnlineTravelAgency: () => OnlineTravelAgency,
  PaymentMethod: () => PaymentMethod,
  PaymentSourceViewKind: () => PaymentSourceViewKind,
  PetPolicyFieldKind: () => PetPolicyFieldKind,
  PoolTypePublicView: () => PoolTypePublicView,
  PropertyType: () => PropertyType,
  PublicBookingReceiptViewDiscountKind: () => PublicBookingReceiptViewDiscountKind,
  RecommendationPlaceTypePublicView: () => RecommendationPlaceTypePublicView,
  ReferralKind: () => ReferralKind,
  RiskLevel: () => RiskLevel,
  RoomKind: () => RoomKind,
  ServiceConstraintKind: () => ServiceConstraintKind,
  ServiceGroup: () => ServiceGroup,
  ServiceKind: () => ServiceKind,
  ServiceRequestRefundPolicy: () => ServiceRequestRefundPolicy,
  ServiceRequestStatus: () => ServiceRequestStatus,
  Stripe: () => Stripe,
  Timeframe: () => Timeframe,
  WalletTransactionKind: () => WalletTransactionKind,
  WifiAp: () => WifiAp,
  arrierePublic: () => arrierePublic,
  default: () => stdin_default
});
var import_endpoint = __toModule(require("@avantstay/graphql-ts-client/dist/endpoint"));
const formatGraphQL = (query) => query;
const BudgetRange = {
  from1000kTo1500k: "FROM1000K_TO1500K",
  from1500kTo2000k: "FROM1500K_TO2000K",
  from2000kAndMore: "FROM2000K_AND_MORE",
  from750kTo1000k: "FROM750K_TO1000K"
};
const CashOrFinanced = {
  cash: "CASH",
  finance: "FINANCE"
};
const ClientType = {
  lighthouse: "LIGHTHOUSE",
  mobile: "MOBILE",
  other: "OTHER",
  web: "WEB"
};
const DocumentKind = {
  customFridgeStock: "CUSTOM_FRIDGE_STOCK",
  eventEmailItinerary: "EVENT_EMAIL_ITINERARY",
  id: "ID",
  other: "OTHER",
  rentalAgreement: "RENTAL_AGREEMENT"
};
const EmailContactAnswerType = {
  maybe: "Maybe",
  no: "No",
  yes: "Yes"
};
const LicensedStates = {
  alabama: "ALABAMA",
  alaska: "ALASKA",
  arizona: "ARIZONA",
  arkansas: "ARKANSAS",
  california: "CALIFORNIA",
  colorado: "COLORADO",
  connecticut: "CONNECTICUT",
  delaware: "DELAWARE",
  florida: "FLORIDA",
  georgia: "GEORGIA",
  hawaii: "HAWAII",
  idaho: "IDAHO",
  illinois: "ILLINOIS",
  indiana: "INDIANA",
  iowa: "IOWA",
  kansas: "KANSAS",
  kentucky: "KENTUCKY",
  louisiana: "LOUISIANA",
  maine: "MAINE",
  maryland: "MARYLAND",
  massachusetts: "MASSACHUSETTS",
  michigan: "MICHIGAN",
  minnesota: "MINNESOTA",
  mississippi: "MISSISSIPPI",
  missouri: "MISSOURI",
  montana: "MONTANA",
  nebraska: "NEBRASKA",
  nevada: "NEVADA",
  newHampshire: "NEW_HAMPSHIRE",
  newJersey: "NEW_JERSEY",
  newMexico: "NEW_MEXICO",
  newYork: "NEW_YORK",
  northCarolina: "NORTH_CAROLINA",
  northDakota: "NORTH_DAKOTA",
  ohio: "OHIO",
  oklahoma: "OKLAHOMA",
  oregon: "OREGON",
  pennsylvania: "PENNSYLVANIA",
  rhodeIsland: "RHODE_ISLAND",
  southCarolina: "SOUTH_CAROLINA",
  southDakota: "SOUTH_DAKOTA",
  tennessee: "TENNESSEE",
  texas: "TEXAS",
  utah: "UTAH",
  vermont: "VERMONT",
  virginia: "VIRGINIA",
  washington: "WASHINGTON",
  westVirginia: "WEST_VIRGINIA",
  wisconsin: "WISCONSIN",
  wyoming: "WYOMING"
};
const PaymentMethod = {
  cash: "Cash",
  finance: "Finance"
};
const Stripe = {
  stripeAch: "STRIPE_ACH",
  stripeAffirm: "STRIPE_AFFIRM",
  stripeCreditCard: "STRIPE_CREDIT_CARD"
};
const Timeframe = {
  asSoonAsPossible: "AS_SOON_AS_POSSIBLE",
  from1To3Months: "FROM1_TO3_MONTHS",
  from4To8Months: "FROM4_TO8_MONTHS",
  from9AndMoreMonths: "FROM9_AND_MORE_MONTHS"
};
const WifiAp = {
  cambium: "CAMBIUM",
  openMesh: "OPEN_MESH",
  solutionInc: "SOLUTION_INC",
  stayfi: "STAYFI",
  website: "WEBSITE"
};
const AmenityTag = {
  accessibility: "ACCESSIBILITY",
  pool: "POOL",
  standard: "STANDARD"
};
const BadgeKind = {
  sparklingClean: "SPARKLING_CLEAN",
  techEnabledLocks: "TECH_ENABLED_LOCKS",
  workFriendlySpace: "WORK_FRIENDLY_SPACE"
};
const BathroomKind = {
  fullBath: "FULL_BATH",
  halfBath: "HALF_BATH",
  indoorOutdoorShower: "INDOOR_OUTDOOR_SHOWER",
  noBath: "NO_BATH",
  sharedBath: "SHARED_BATH"
};
const BookKind = {
  manual: "MANUAL",
  recommendation: "RECOMMENDATION",
  rules: "RULES"
};
const BookingFlexibility = {
  checkTime: "CHECK_TIME",
  services: "SERVICES"
};
const BookingIdVerificationStatus = {
  awaiting: "AWAITING",
  passed: "PASSED",
  underReview: "UNDER_REVIEW"
};
const BookingItemSummaryKind = {
  adjustment: "ADJUSTMENT",
  deposit: "DEPOSIT",
  discount: "DISCOUNT",
  fee: "FEE",
  night: "NIGHT",
  service: "SERVICE",
  tax: "TAX"
};
const BookingPaymentBalanceStatus = {
  fullyPaid: "FULLY_PAID",
  notPaid: "NOT_PAID",
  overPaid: "OVER_PAID",
  partlyPaid: "PARTLY_PAID"
};
const BookingStatus = {
  booked: "BOOKED",
  cancelled: "CANCELLED",
  checkedIn: "CHECKED_IN",
  checkedOut: "CHECKED_OUT",
  modified: "MODIFIED",
  noShow: "NO_SHOW",
  quoted: "QUOTED",
  requested: "REQUESTED"
};
const CancellationPolicyType = {
  nonRefundable: "NON_REFUNDABLE",
  refundable: "REFUNDABLE",
  refundPlusTravelCard: "REFUND_PLUS_TRAVEL_CARD"
};
const ChannelCancellationKind = {
  booking: "BOOKING",
  valueAddedService: "VALUE_ADDED_SERVICE"
};
const ChannelCancellationStatus = {
  active: "ACTIVE",
  expired: "EXPIRED"
};
const CollectionKind = {
  beach: "BEACH",
  desert: "DESERT",
  event: "EVENT",
  groupStay: "GROUP_STAY",
  luxury: "LUXURY",
  mountain: "MOUNTAIN",
  petFriendly: "PET_FRIENDLY",
  snowbird: "SNOWBIRD",
  urban: "URBAN"
};
const CommunicationCategoryKey = {
  airbnb: "AIRBNB",
  bookingExternal: "BOOKING_EXTERNAL",
  checkInDetails: "CHECK_IN_DETAILS",
  conciergeMarketing: "CONCIERGE_MARKETING",
  conciergeMarketingEstates: "CONCIERGE_MARKETING_ESTATES",
  contract: "CONTRACT",
  experience: "EXPERIENCE",
  gilmore: "GILMORE",
  id: "ID",
  inStayFollowUp: "IN_STAY_FOLLOW_UP",
  orphanNight: "ORPHAN_NIGHT",
  ownerNotification: "OWNER_NOTIFICATION",
  payment: "PAYMENT",
  push: "PUSH",
  referrals: "REFERRALS",
  vas: "VAS",
  vendor: "VENDOR",
  welcome: "WELCOME"
};
const ConfirmationStep = {
  appDownload: "APP_DOWNLOAD",
  checkTime: "CHECK_TIME",
  contactInfoVerified: "CONTACT_INFO_VERIFIED",
  guestsAdded: "GUESTS_ADDED",
  paid: "PAID",
  personalized: "PERSONALIZED",
  protected: "PROTECTED",
  valueAddedServices: "VALUE_ADDED_SERVICES",
  verified: "VERIFIED"
};
const ContactKind = {
  email: "EMAIL",
  phone: "PHONE"
};
const ContractSignStatus = {
  signed: "SIGNED",
  unsigned: "UNSIGNED"
};
const ContractStatus = {
  bookingBinded: "BOOKING_BINDED",
  bookingUnbound: "BOOKING_UNBOUND",
  cancelled: "CANCELLED",
  completed: "COMPLETED",
  created: "CREATED",
  declined: "DECLINED",
  failed: "FAILED",
  sent: "SENT"
};
const CountryStatesChoice = {
  list: "List",
  none: "None",
  text: "Text"
};
const CreditCardType = {
  americanExpress: "AMERICAN_EXPRESS",
  amex: "AMEX",
  cartesBancaires: "CARTES_BANCAIRES",
  dinersClub: "DINERS_CLUB",
  discover: "DISCOVER",
  jcb: "JCB",
  mastercard: "MASTERCARD",
  other: "OTHER",
  unionPay: "UNION_PAY",
  visa: "VISA"
};
const CreditsReason = {
  bookingCancellation: "BookingCancellation",
  bookingSelfCancellation: "BookingSelfCancellation",
  checkInProcess: "CheckInProcess",
  cleanliness: "Cleanliness",
  concierge: "Concierge",
  covid: "Covid",
  creditTransferToAnotherGuest: "CreditTransferToAnotherGuest",
  discountCode: "DiscountCode",
  employeeCredits: "EmployeeCredits",
  festivalSecurityDeposit: "FestivalSecurityDeposit",
  fiveStarGuest: "FiveStarGuest",
  guestResolution: "GuestResolution",
  homeownerAtFault: "HomeownerAtFault",
  hvac: "Hvac",
  internet: "Internet",
  lackingAmenities: "LackingAmenities",
  lossOfProperty: "LossOfProperty",
  maintenanceIssues: "MaintenanceIssues",
  marketingCampaign: "MarketingCampaign",
  midStayCLeanRefund: "MidStayCLeanRefund",
  misrepresentedListing: "MisrepresentedListing",
  mistakeCorrection: "MistakeCorrection",
  overpayment: "Overpayment",
  parking: "Parking",
  pinnacleMaintenance: "PinnacleMaintenance",
  poolEquipment: "PoolEquipment",
  poolHeat: "PoolHeat",
  propertyNotGuestReady: "PropertyNotGuestReady",
  referralCredit: "ReferralCredit",
  refundedInstead: "RefundedInstead",
  reservationCanceledByHost: "ReservationCanceledByHost",
  reservationCancelledByGuest: "ReservationCancelledByGuest",
  reviewNotRemoved: "ReviewNotRemoved",
  reviewRemoval: "ReviewRemoval",
  safetyIssues: "SafetyIssues",
  securityDeposit: "SecurityDeposit",
  shippingReimbursement: "ShippingReimbursement",
  spaEquipment: "SpaEquipment",
  vipCredit: "VipCredit",
  water: "Water",
  wireReceivedInstead: "WireReceivedInstead"
};
const CreditsSourceKind = {
  bookingRefund: "BookingRefund",
  bookingRefundWithExpiration: "BookingRefundWithExpiration",
  expirationWithdraw: "ExpirationWithdraw",
  manuallyAdded: "ManuallyAdded",
  manuallyWithdraw: "ManuallyWithdraw",
  preBookingRefund: "PreBookingRefund",
  referralInvitation: "ReferralInvitation",
  referralSubscription: "ReferralSubscription",
  withdraw: "Withdraw"
};
const DiscountBadgeIcon = {
  dollarSign: "DollarSign",
  none: "None"
};
const FeeKind = {
  optional: "OPTIONAL",
  petFee: "PET_FEE",
  required: "REQUIRED",
  securityDeposit: "SECURITY_DEPOSIT",
  tax: "TAX"
};
const FridgePackageOrderStatus = {
  inProgress: "IN_PROGRESS",
  orderNotPlaced: "ORDER_NOT_PLACED",
  orderPlaced: "ORDER_PLACED"
};
const GuestInvitationStatus = {
  accepted: "ACCEPTED",
  pending: "PENDING"
};
const GuestType = {
  ownerGuest: "OWNER_GUEST",
  regularGuest: "REGULAR_GUEST"
};
const HomeDateOccupancyStatus = {
  checkIn: "CHECK_IN",
  checkOut: "CHECK_OUT",
  checkOutAndCheckIn: "CHECK_OUT_AND_CHECK_IN",
  occupied: "OCCUPIED",
  vacant: "VACANT"
};
const HomeQuerySorting = {
  homeName: "HOME_NAME",
  homeNameDesc: "HOME_NAME_DESC",
  occupancy: "OCCUPANCY",
  priceAsc: "PRICE_ASC",
  priceDesc: "PRICE_DESC",
  promoted: "PROMOTED",
  regionName: "REGION_NAME",
  relevance: "RELEVANCE",
  updatingDate: "UPDATING_DATE"
};
const HowDidYouHearAboutUs = {
  familyOrFriend: "FAMILY_OR_FRIEND",
  other: "OTHER",
  searchEngine: "SEARCH_ENGINE",
  socialMedia: "SOCIAL_MEDIA",
  thirdPartyPlatform: "THIRD_PARTY_PLATFORM"
};
const InputPaymentMode = {
  ach: "ACH",
  creditCard: "CREDIT_CARD",
  stripeAch: "STRIPE_ACH",
  stripeAffirm: "STRIPE_AFFIRM",
  stripeCreditCard: "STRIPE_CREDIT_CARD"
};
const LeadSource = {
  acqDirect: "ACQ_DIRECT",
  airBnb: "AIR_BNB",
  allegiantAir: "ALLEGIANT_AIR",
  beachside: "BEACHSIDE",
  beachGirls: "BEACH_GIRLS",
  blueGround: "BLUE_GROUND",
  bnbFinder: "BNB_FINDER",
  bonotel: "BONOTEL",
  bookingCom: "BOOKING_COM",
  capitalOne: "CAPITAL_ONE",
  expedia: "EXPEDIA",
  frontdesk: "FRONTDESK",
  gilmore: "GILMORE",
  google: "GOOGLE",
  googleTravel: "GOOGLE_TRAVEL",
  homesAndVillas: "HOMES_AND_VILLAS",
  homeAway: "HOME_AWAY",
  homeToGo: "HOME_TO_GO",
  hopper: "HOPPER",
  hotelTonight: "HOTEL_TONIGHT",
  lakecations: "LAKECATIONS",
  lighthouse: "LIGHTHOUSE",
  marriott: "MARRIOTT",
  mobile: "MOBILE",
  monkeyTree: "MONKEY_TREE",
  nonPayingGuest: "NON_PAYING_GUEST",
  other: "OTHER",
  overmoon: "OVERMOON",
  quintess: "QUINTESS",
  rentalsUnited: "RENTALS_UNITED",
  stayHvn: "STAY_HVN",
  staySense: "STAY_SENSE",
  theWesley: "THE_WESLEY",
  topVillas: "TOP_VILLAS",
  travelStaytion: "TRAVEL_STAYTION",
  tripAdvisor: "TRIP_ADVISOR",
  vacationRenter: "VACATION_RENTER",
  voyage: "VOYAGE",
  vrbo: "VRBO",
  website: "WEBSITE",
  whimstay: "WHIMSTAY"
};
const LinkStatus = {
  active: "ACTIVE",
  cancelled: "CANCELLED",
  confirmed: "CONFIRMED",
  paid: "PAID"
};
const ListingKind = {
  homeListing: "HOME_LISTING",
  hotelListing: "HOTEL_LISTING",
  hotelRoomListing: "HOTEL_ROOM_LISTING"
};
const ListingPropertyType = {
  apartment: "APARTMENT",
  hotel: "HOTEL",
  house: "HOUSE"
};
const ListingQuerySorting = {
  priceAsc: "PRICE_ASC",
  priceDesc: "PRICE_DESC",
  relevance: "RELEVANCE"
};
const OnlineTravelAgency = {
  acqDirect: "ACQ_DIRECT",
  airbnb: "AIRBNB",
  blueGround: "BLUE_GROUND",
  bnbFinder: "BNB_FINDER",
  bonotel: "BONOTEL",
  bookingCom: "BOOKING_COM",
  capitalOne: "CAPITAL_ONE",
  direct: "DIRECT",
  expedia: "EXPEDIA",
  google: "GOOGLE",
  googleTravel: "GOOGLE_TRAVEL",
  homesAndVillas: "HOMES_AND_VILLAS",
  homeToGo: "HOME_TO_GO",
  hopper: "HOPPER",
  hotelTonight: "HOTEL_TONIGHT",
  marriott: "MARRIOTT",
  quintess: "QUINTESS",
  rentalsUnited: "RENTALS_UNITED",
  stayHvn: "STAY_HVN",
  staySense: "STAY_SENSE",
  topVillas: "TOP_VILLAS",
  travelStaytion: "TRAVEL_STAYTION",
  tripAdvisor: "TRIP_ADVISOR",
  vacationRenter: "VACATION_RENTER",
  vrbo: "VRBO",
  whimstay: "WHIMSTAY"
};
const PaymentSourceViewKind = {
  ach: "ACH",
  affirm: "AFFIRM",
  card: "CARD",
  cashTransferRefund: "CASH_TRANSFER_REFUND",
  credits: "CREDITS",
  creditsRefund: "CREDITS_REFUND",
  deferred: "DEFERRED",
  deposit: "DEPOSIT",
  manualRefund: "MANUAL_REFUND",
  paymentLink: "PAYMENT_LINK",
  securityDeposit: "SECURITY_DEPOSIT",
  streamline: "STREAMLINE",
  stripeBankAccount: "STRIPE_BANK_ACCOUNT",
  stripeCard: "STRIPE_CARD",
  stripeDeferred: "STRIPE_DEFERRED",
  stripeLink: "STRIPE_LINK",
  stripeOther: "STRIPE_OTHER",
  wholesale: "WHOLESALE"
};
const PetPolicyFieldKind = {
  approved: "APPROVED",
  notApproved: "NOT_APPROVED",
  other: "OTHER",
  unknown: "UNKNOWN"
};
const PoolTypePublicView = {
  communalPool: "COMMUNAL_POOL",
  privatePool: "PRIVATE_POOL"
};
const PropertyType = {
  apartment: "APARTMENT",
  hotel: "HOTEL",
  house: "HOUSE"
};
const PublicBookingReceiptViewDiscountKind = {
  coupon: "COUPON",
  longTerm: "LONG_TERM",
  travelAgent: "TRAVEL_AGENT"
};
const RecommendationPlaceTypePublicView = {
  activity: "Activity",
  restaurant: "Restaurant",
  shopping: "Shopping"
};
const ReferralKind = {
  guest: "Guest",
  homeOwner: "HomeOwner"
};
const RiskLevel = {
  high: "HIGH",
  low: "LOW",
  medium: "MEDIUM",
  minimal: "MINIMAL",
  undefined: "UNDEFINED",
  veryHigh: "VERY_HIGH",
  veryLow: "VERY_LOW"
};
const RoomKind = {
  backyard: "BACKYARD",
  balcony: "BALCONY",
  bar: "BAR",
  basement: "BASEMENT",
  bedroom: "BEDROOM",
  childrensPlayroom: "CHILDRENS_PLAYROOM",
  courtyard: "COURTYARD",
  diningRoom: "DINING_ROOM",
  entry: "ENTRY",
  eventRoom: "EVENT_ROOM",
  familyRoom: "FAMILY_ROOM",
  fitnessRoom: "FITNESS_ROOM",
  frontYard: "FRONT_YARD",
  fullBathroom: "FULL_BATHROOM",
  gameRoom: "GAME_ROOM",
  garage: "GARAGE",
  generalExterior: "GENERAL_EXTERIOR",
  halfBathroom: "HALF_BATHROOM",
  hotTub: "HOT_TUB",
  kitchen: "KITCHEN",
  kitchenette: "KITCHENETTE",
  laundryRoom: "LAUNDRY_ROOM",
  livingRoom: "LIVING_ROOM",
  livingSleepingCombo: "LIVING_SLEEPING_COMBO",
  lobby: "LOBBY",
  movieTheater: "MOVIE_THEATER",
  neighborhood: "NEIGHBORHOOD",
  office: "OFFICE",
  other: "OTHER",
  otherSleepingArea: "OTHER_SLEEPING_AREA",
  outdoor: "OUTDOOR",
  outdoorCommonArea: "OUTDOOR_COMMON_AREA",
  patio: "PATIO",
  pool: "POOL",
  porch: "PORCH",
  rooftop: "ROOFTOP",
  spa: "SPA"
};
const ServiceConstraintKind = {
  bookAhead: "BookAhead",
  minimumOrder: "MinimumOrder",
  other: "Other"
};
const ServiceGroup = {
  checkInOut: "CheckInOut",
  filmAndPhoto: "FilmAndPhoto",
  finesAndDamages: "FinesAndDamages",
  foodAndBeverage: "FoodAndBeverage",
  hOAResortFee: "HOAResortFee",
  homeEssentials: "HomeEssentials",
  housekeepingServices: "HousekeepingServices",
  merchandise: "Merchandise",
  partnershipEvents: "PartnershipEvents",
  pets: "Pets",
  poolAndHotTub: "PoolAndHotTub",
  recreation: "Recreation",
  thirdParty: "ThirdParty",
  transportation: "Transportation",
  wellness: "Wellness"
};
const ServiceKind = {
  arbitrary: "Arbitrary",
  basic: "Basic",
  checkTime: "CheckTime",
  datesBased: "DatesBased",
  itemBased: "ItemBased",
  midStayCleaning: "MidStayCleaning",
  poolHeating: "PoolHeating",
  stockedFridge: "StockedFridge",
  thirdParty: "ThirdParty"
};
const ServiceRequestRefundPolicy = {
  fullRefund: "FULL_REFUND",
  nonRefundable: "NON_REFUNDABLE",
  partialRefund: "PARTIAL_REFUND",
  uponApproval: "UPON_APPROVAL"
};
const ServiceRequestStatus = {
  aborted: "Aborted",
  cancelled: "Cancelled",
  confirmed: "Confirmed",
  expired: "Expired",
  rejected: "Rejected",
  requested: "Requested",
  settled: "Settled"
};
const WalletTransactionKind = {
  deposit: "DEPOSIT",
  withdrawal: "WITHDRAWAL"
};
const typesTree = {
  BookingGuestMutations: {
    get addGuestPayments() {
      return {
        __args: {
          bookingId: "UUID!",
          payments: "[GuestPaymentInput!]!"
        }
      };
    },
    get createPaymentIntent() {
      return {
        __args: {
          bookingId: "UUID!",
          personId: "UUID!"
        }
      };
    },
    get addGuest() {
      return {
        __args: {
          bookingId: "UUID!",
          name: "String!",
          email: "String",
          phone: "String",
          room: "UUID"
        }
      };
    },
    get addGuests() {
      return {
        __args: {
          bookingId: "UUID!",
          guestInfoInputs: "[GuestInfoInput!]!"
        }
      };
    },
    get removeGuest() {
      return {
        __args: {
          bookingId: "UUID!",
          email: "String",
          phone: "String",
          personId: "UUID"
        }
      };
    },
    get changeGuestRoom() {
      return {
        __args: {
          bookingId: "UUID!",
          email: "String",
          phone: "String",
          room: "UUID"
        }
      };
    }
  },
  BookingMutations: {
    get updateCancelledRequestsToBeNotifiedDate() {
      return {
        __args: {
          bookingId: "UUID!",
          lastStatusChangedAt: "LocalDateTime!"
        }
      };
    }
  },
  Mutation: {
    get isEmailAlreadyInUse() {
      return {
        __args: {
          email: "String!"
        }
      };
    },
    get createGuestWithPhone() {
      return {
        __args: {
          guestInputWithPhone: "GuestInputWithPhone!",
          signUpSource: "String"
        }
      };
    },
    get createGuest() {
      return {
        __fields: typesTree.User,
        __args: {
          guestCreateInput: "GuestCreateInput!",
          referralToken: "Int",
          isCheckout: "Boolean",
          signUpSource: "String"
        }
      };
    },
    get createGuestFromInvite() {
      return {
        __args: {
          token: "String!",
          newPassword: "String!",
          clientType: "ClientType",
          signUpSource: "String"
        }
      };
    },
    get createGuestFromReferral() {
      return {
        __fields: typesTree.User,
        __args: {
          referralToken: "Int!",
          guestCreateInput: "GuestCreateInput!",
          signUpSource: "String"
        }
      };
    },
    get updateGuest() {
      return {
        __args: {
          input: "GuestUpdateInput!"
        }
      };
    },
    get changeGuestPhone() {
      return {
        __args: {
          phone: "String!",
          code: "Int!"
        }
      };
    },
    get confirmEmail() {
      return {
        __args: {
          confirmationCode: "String!"
        }
      };
    },
    get updatePassword() {
      return {
        __args: {
          updatePassword: "UpdatePasswordInput!"
        }
      };
    },
    get login() {
      return {
        __args: {
          email: "String!",
          password: "String!",
          clientType: "ClientType"
        }
      };
    },
    get refreshToken() {
      return {
        __args: {
          refreshToken: "String!"
        }
      };
    },
    get validatePhone() {
      return {
        __args: {
          phone: "String!",
          verificationCode: "Int!"
        }
      };
    },
    get createNewUser() {
      return {
        __args: {
          phone: "String!",
          verificationCode: "Int!",
          email: "String!",
          name: "String!"
        }
      };
    },
    get createNewUserWithPassword() {
      return {
        __args: {
          phone: "String!",
          verificationCode: "Int!",
          email: "String!",
          name: "String!",
          password: "String!"
        }
      };
    },
    get sendSmsVerificationCode() {
      return {
        __args: {
          phone: "String!"
        }
      };
    },
    get requestPhoneVerificationCode() {
      return {
        __args: {
          phone: "String!"
        }
      };
    },
    get requestPhoneVerificationCodeSecure() {
      return {
        __args: {
          phone: "String!",
          token: "String!"
        }
      };
    },
    get resendPhoneVerificationCodeSecure() {
      return {
        __args: {
          phone: "String!",
          token: "String"
        }
      };
    },
    get requestMagicLink() {
      return {
        __args: {
          email: "String!"
        }
      };
    },
    get verifyMagicLink() {
      return {
        __args: {
          code: "String!"
        }
      };
    },
    get verifyPhoneVerificationCode() {
      return {
        __args: {
          phone: "String!",
          code: "Int!"
        }
      };
    },
    get requestPasswordReset() {
      return {
        __args: {
          email: "String!"
        }
      };
    },
    get resetPassword() {
      return {
        __args: {
          resetPassword: "ResetPasswordInput!"
        }
      };
    },
    get addPushToken() {
      return {
        __args: {
          pushToken: "String!"
        }
      };
    },
    get conciergeFormProps() {
      return {
        __args: {
          groceryServices: "Boolean!",
          chefServices: "Boolean!",
          spaServices: "Boolean!",
          toursAndActivities: "Boolean!",
          transportation: "Boolean!",
          other: "Boolean!",
          otherText: "String",
          anythingElseText: "String",
          bookingId: "String",
          guestName: "String"
        }
      };
    },
    get updateOptout() {
      return {
        __args: {
          personId: "UUID!",
          optouts: "[CommunicationCategoryKey!]",
          optins: "[CommunicationCategoryKey!]"
        }
      };
    },
    get subscribeToMailingListV2() {
      return {
        __args: {
          firstName: "String!",
          email: "String!",
          wifiAp: "WifiAp",
          source: "String",
          signUpSource: "String"
        }
      };
    },
    get subscribeOwnerToMailingList() {
      return {
        __args: {
          firstName: "String!",
          email: "String!",
          source: "String"
        }
      };
    },
    get setPasswordIfNotExists() {
      return {
        __args: {
          newPassword: "String!"
        }
      };
    },
    get generateAssetUploadUrl() {
      return {
        __args: {
          extension: "String!",
          size: "Long!"
        }
      };
    },
    get requestBookingPayment() {
      return {
        __args: {
          booking: "BookingRequestInput!",
          billingAddress: "NewAddress",
          contact: "NewContactDetails",
          documentId: "UUID",
          paymentPlan: "Boolean",
          insurance: "Insurance"
        }
      };
    },
    get requestBookingPaymentUsingCard() {
      return {
        __args: {
          booking: "BookingRequestInput!",
          paymentCardId: "UUID!",
          contact: "NewContactDetails",
          documentId: "UUID",
          paymentPlan: "Boolean!",
          insurance: "Insurance",
          billingAddress: "NewAddress"
        }
      };
    },
    get requestBookingPaymentWithAffirm() {
      return {
        __args: {
          booking: "BookingRequestInput!",
          billingAddress: "NewAddress",
          contact: "NewContactDetails",
          documentId: "UUID",
          walletAmount: "BigInt",
          affirmToken: "String!",
          paymentCardId: "UUID",
          stripePaymentMethod: "String",
          paymentPlan: "Boolean"
        }
      };
    },
    get requestBookingPaymentWithACH() {
      return {
        __args: {
          booking: "BookingRequestInput!",
          billingAddress: "NewAddress",
          documentId: "UUID",
          walletAmount: "BigInt",
          contact: "NewContactDetails",
          achInput: "ACHPaymentInput!"
        }
      };
    },
    get requestBookingPaymentWithWallet() {
      return {
        __args: {
          booking: "BookingRequestInput!",
          walletAmount: "BigInt!",
          billingAddress: "NewAddress",
          contact: "NewContactDetails",
          documentId: "UUID",
          paymentPlan: "Boolean",
          insurance: "Insurance"
        }
      };
    },
    get requestBookingPaymentUsingCardWithWallet() {
      return {
        __args: {
          booking: "BookingRequestInput!",
          paymentCardId: "UUID!",
          walletAmount: "BigInt!",
          contact: "NewContactDetails",
          documentId: "UUID",
          paymentPlan: "Boolean!",
          insurance: "Insurance",
          billingAddress: "NewAddress"
        }
      };
    },
    get initializeCartPayment() {
      return {
        __args: {
          cartId: "UUID!"
        }
      };
    },
    get updateCartPaymentPrice() {
      return {
        __args: {
          cartId: "UUID!",
          paymentMode: "Stripe!"
        }
      };
    },
    get setCartPayment() {
      return {
        __args: {
          cartId: "UUID!",
          paymentMode: "Stripe"
        }
      };
    },
    get confirmCartPayment() {
      return {
        __fields: typesTree.CartConfirmPayment,
        __args: {
          cartId: "UUID!",
          paymentCardId: "UUID",
          withInsurance: "Boolean"
        }
      };
    },
    get confirmBookingPayment() {
      return {
        __args: {
          requestId: "UUID!"
        }
      };
    },
    get attachDocument() {
      return {
        __args: {
          token: "String!",
          documentId: "UUID!"
        }
      };
    },
    get selfBookingCancellation() {
      return {
        __args: {
          bookingId: "UUID!",
          reason: "String!",
          note: "String"
        }
      };
    },
    get addMyBookingGuest() {
      return {
        __args: {
          bookingHash: "String!",
          lastName: "String"
        }
      };
    },
    get requestServices() {
      return {
        __args: {
          bookingId: "UUID!",
          requests: "[ServiceRequestInfoInput!]!",
          cardId: "UUID",
          token: "String"
        }
      };
    },
    get requestServicesOrder() {
      return {
        __args: {
          bookingId: "UUID!",
          requests: "[ServiceRequestInfoInput!]!"
        }
      };
    },
    get requestEarlyCheckIn() {
      return {
        __args: {
          bookingId: "UUID!",
          time: "LocalTime!",
          comment: "String"
        }
      };
    },
    get requestEarlyCheckInWithBookingCard() {
      return {
        __args: {
          bookingId: "UUID!",
          time: "LocalTime!",
          cardId: "UUID!",
          comment: "String"
        }
      };
    },
    get requestLateCheckOut() {
      return {
        __args: {
          bookingId: "UUID!",
          time: "LocalTime!",
          comment: "String"
        }
      };
    },
    get requestLateCheckOutWithBookingCard() {
      return {
        __args: {
          bookingId: "UUID!",
          time: "LocalTime!",
          cardId: "UUID!",
          comment: "String"
        }
      };
    },
    get requestCheckTime() {
      return {
        __args: {
          bookingId: "UUID!",
          serviceId: "UUID!",
          time: "LocalTime!",
          cardId: "UUID",
          comment: "String",
          token: "String"
        }
      };
    },
    get requestPoolHeating() {
      return {
        __args: {
          bookingId: "UUID!",
          serviceId: "UUID!",
          dates: "[LocalDate!]!",
          cardId: "UUID",
          comment: "String"
        }
      };
    },
    get requestPoolHeatingRemainingStay() {
      return {
        __args: {
          bookingId: "UUID!",
          serviceId: "UUID!",
          cardId: "UUID",
          comment: "String",
          token: "String"
        }
      };
    },
    get requestStockedFridge() {
      return {
        __args: {
          bookingId: "UUID!",
          token: "String",
          serviceId: "UUID!",
          packages: "[PackageInput!]!",
          cardId: "UUID",
          comment: "String"
        }
      };
    },
    get requestCustomStockedFridgeService() {
      return {
        __args: {
          bookingId: "UUID!",
          request: "CustomFridgeStockInput!",
          token: "String"
        }
      };
    },
    get requestStockedFridgeService() {
      return {
        __args: {
          bookingId: "UUID!",
          token: "String",
          serviceId: "UUID!",
          packages: "[ServiceFridgePackageInput!]!",
          cardId: "UUID",
          comment: "String"
        }
      };
    },
    get requestMidStayClean() {
      return {
        __args: {
          bookingId: "UUID!",
          serviceId: "UUID!",
          date: "LocalDate!",
          cardId: "UUID",
          comment: "String",
          token: "String"
        }
      };
    },
    get createLiveAgreement() {
      return {
        __args: {
          bookingId: "UUID!",
          documentId: "UUID!",
          markdown: "String"
        }
      };
    },
    get requestItemBasedService() {
      return {
        __args: {
          bookingId: "UUID!",
          serviceId: "UUID!",
          number: "Int!",
          cardId: "UUID",
          comment: "String",
          token: "String"
        }
      };
    },
    get requestBasicService() {
      return {
        __args: {
          bookingId: "UUID!",
          serviceId: "UUID!",
          cardId: "UUID",
          comment: "String"
        }
      };
    },
    get uploadMarketingInfo() {
      return {
        __args: {
          bookingId: "UUID!",
          marketingInfo: "MarketingInfoInput!"
        }
      };
    },
    get updateMarketingGuests() {
      return {
        __args: {
          bookingId: "UUID!",
          adults: "Int",
          children: "Int",
          infants: "Int"
        }
      };
    },
    get addBookingConfirmationCompletedStep() {
      return {
        __args: {
          bookingId: "UUID!",
          completedStep: "ConfirmationStep!"
        }
      };
    },
    get requestConciergeServices() {
      return {
        __args: {
          bookingId: "UUID!",
          services: "[String!]!",
          message: "String!"
        }
      };
    },
    get signContract() {
      return {
        __args: {
          bookingId: "UUID!",
          token: "String"
        }
      };
    },
    get registerBookingOwner() {
      return {
        __args: {
          bookingId: "UUID!",
          token: "String",
          password: "String!"
        }
      };
    },
    get requestContact() {
      return {
        __args: {
          request: "ContactRequestInput!"
        }
      };
    },
    get eventEmailContact() {
      return {
        __args: {
          request: "EventEmailContactInput!"
        }
      };
    },
    get buyerContact() {
      return {
        __args: {
          request: "BuyerContactInput!"
        }
      };
    },
    get sellerContact() {
      return {
        __args: {
          request: "SellerContactInput!"
        }
      };
    },
    get agentContact() {
      return {
        __args: {
          request: "AgentContactInput!"
        }
      };
    },
    get brokerContact() {
      return {
        __args: {
          request: "BrokerContactInput!"
        }
      };
    },
    get requestPartnership() {
      return {
        __args: {
          request: "PartnershipRequestInput!"
        }
      };
    },
    get requestRetreatProposal() {
      return {
        __args: {
          content: "String!"
        }
      };
    },
    get newAgentLead() {
      return {
        __args: {
          fullName: "String!",
          email: "String!",
          phone: "String!",
          brokerage: "String!"
        }
      };
    },
    get newBuyerLeadStep1() {
      return {
        __args: {
          id: "UUID!",
          fullName: "String!",
          email: "String!",
          phone: "String!",
          marketsOfInterest: "String!"
        }
      };
    },
    get newBuyerLeadStep2() {
      return {
        __args: {
          id: "UUID!",
          fullName: "String!",
          email: "String!",
          phone: "String!",
          marketsOfInterest: "String!",
          purchasePriceRange: "RangeInput!",
          purchaseReadiness: "ReadinessInput!",
          purchaseMethod: "PaymentMethod!",
          familiarWithMasterLease: "Boolean!"
        }
      };
    },
    get newSellerLead() {
      return {
        __args: {
          fullName: "String!",
          email: "String!",
          phone: "String!",
          zipCode: "String!",
          message: "String!"
        }
      };
    },
    get createDocument() {
      return {
        __args: {
          documentRequest: "DocumentRequest!"
        }
      };
    },
    get trackEvent() {
      return {
        __args: {
          personId: "UUID",
          bookingId: "UUID",
          action: "String!",
          metadata: "Json!"
        }
      };
    },
    get generateTrackedUrl() {
      return {
        __args: {
          url: "String!",
          bookingId: "UUID",
          action: "String!",
          metadata: "Json!"
        }
      };
    },
    get calculateYourRevenue() {
      return {
        __args: {
          name: "String!",
          email: "String!",
          phone: "String",
          address: "String!",
          bedrooms: "Int!",
          bathrooms: "Float!",
          accommodates: "Int!",
          message: "String",
          referralToken: "String",
          referringAvantStayPage: "String",
          gclid: "String",
          utmCampaign: "String",
          utmContent: "String",
          utmSource: "String",
          utmMedium: "String",
          utmTerm: "String"
        }
      };
    },
    get salesLeadStep() {
      return {
        __args: {
          requestId: "String!",
          name: "String!",
          email: "String!",
          isFinal: "Boolean",
          phone: "String",
          address: "String",
          bedrooms: "Int",
          bathrooms: "BigDecimal",
          heardAboutUs: "String",
          useFrequency: "String",
          managementType: "String",
          listingLink: "String",
          leadSourceUrl: "String",
          message: "String",
          referralToken: "String",
          propertyAddress: "LeadAddress",
          homeOwnerAddress: "LeadAddress",
          referringAvantStayPage: "String",
          gclid: "String",
          utmCampaign: "String",
          utmContent: "String",
          utmSource: "String",
          utmMedium: "String",
          utmTerm: "String"
        }
      };
    },
    get sendEmailInvitation() {
      return {
        __args: {
          emails: "[String!]!",
          homeOwner: "HomeOwnerInput"
        }
      };
    },
    get sendEmailInvitationByHash() {
      return {
        __args: {
          hash: "Int!",
          emails: "[String!]!",
          homeOwner: "HomeOwnerInput"
        }
      };
    },
    get createInvitationHash() {
      return {
        __args: {
          email: "String!",
          name: "String!",
          signUpSource: "String"
        }
      };
    },
    get applyForDigitalDuos() {
      return {
        __args: {
          mainFullName: "String!",
          mainEmail: "String!",
          mainBirthDate: "LocalDate!",
          mainState: "String!",
          mainCity: "String!",
          mainTikTok: "String!",
          mainInstagram: "String!",
          partnerFullName: "String!",
          partnerEmail: "String!",
          partnerBirthDate: "LocalDate!",
          partnerState: "String!",
          partnerCity: "String!",
          partnerTikTok: "String!",
          partnerInstagram: "String!",
          reason: "String!",
          reels: "[String!]!",
          promotionConsent: "Boolean!"
        }
      };
    },
    get submitEstimates() {
      return {
        __args: {
          email: "String!",
          phone: "String!",
          name: "String!",
          bedrooms: "Int",
          bathrooms: "Int",
          tags: "[String!]!",
          adr: "BigDecimal",
          revenueLower: "BigDecimal",
          revenueUpper: "BigDecimal",
          street: "String!",
          city: "String!",
          state: "String!",
          zip: "String!",
          leadSourceUrl: "String!",
          utmCampaign: "String",
          utmSource: "String",
          utmMedium: "String",
          gclid: "String",
          utmTerm: "String",
          utmContent: "String"
        }
      };
    },
    get submitVRM() {
      return {
        __args: {
          street: "String!",
          city: "String!",
          state: "String!",
          zip: "String",
          firstName: "String!",
          lastName: "String!",
          leadSourceUrl: "String!",
          email: "String",
          phone: "String",
          message: "String",
          utmCampaign: "String",
          utmSource: "String",
          utmMedium: "String",
          gclid: "String",
          utmTerm: "String",
          utmContent: "String",
          destination: "String",
          leadSource: "String"
        }
      };
    },
    get submitSellerLead() {
      return {
        __args: {
          fullName: "String!",
          email: "String",
          phone: "String",
          zip: "String!",
          message: "String",
          leadSourceUrl: "String!",
          utmCampaign: "String",
          utmMedium: "String",
          utmSource: "String",
          gclid: "String",
          marketsOfInterest: "String!"
        }
      };
    },
    get submitBuyerLead() {
      return {
        __args: {
          firstName: "String!",
          lastName: "String!",
          email: "String",
          phone: "String",
          utmCampaign: "String",
          utmSource: "String",
          utmMedium: "String",
          gclid: "String",
          marketsOfInterest: "String",
          timeframe: "Timeframe!",
          budgedRange: "BudgetRange!",
          cashOrFinanced: "CashOrFinanced!",
          leadSourceUrl: "String!"
        }
      };
    },
    get submitAgentLead() {
      return {
        __args: {
          name: "String!",
          brokerage: "String!",
          email: "String",
          phone: "String",
          utmCampaign: "String",
          utmSource: "String",
          utmMedium: "String",
          gclid: "String",
          marketsOfInterest: "String",
          licensedStates: "[LicensedStates!]!",
          licensedAgent: "Boolean!",
          notes: "String",
          leadSourceUrl: "String!"
        }
      };
    },
    get booking() {
      return {
        __fields: typesTree.BookingMutations
      };
    },
    get bookingGuests() {
      return {
        __fields: typesTree.BookingGuestMutations
      };
    },
    get purchase() {
      return {
        __fields: typesTree.PurchasePublicMutations
      };
    }
  },
  PurchasePublicMutations: {
    get settleBookingPayment() {
      return {
        __args: {
          intentId: "String!",
          name: "String!"
        }
      };
    },
    get fulfillPayment() {
      return {
        __args: {
          requestId: "UUID!",
          intentId: "String!"
        }
      };
    },
    get settle() {
      return {
        __args: {
          requestId: "UUID!"
        }
      };
    },
    get initializePayment() {
      return {
        __args: {
          requestId: "UUID!"
        }
      };
    },
    get initializeBookingPayment() {
      return {
        __args: {
          intentId: "String!"
        }
      };
    }
  },
  Booking: {
    get balancePaymentUsingCard() {
      return {
        __args: {
          paymentCardId: "UUID!"
        }
      };
    },
    get availableServices() {
      return {
        __fields: typesTree.PubliclyAvailableService,
        __args: {
          ofKinds: "[ServiceKind!]"
        }
      };
    },
    get availableService() {
      return {
        __fields: typesTree.PubliclyAvailableService,
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get checkTimeOptions() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get midStayCleaningOptions() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get poolHeatingOptions() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get poolHeatingOption() {
      return {
        __fields: typesTree.PoolHeatingFullStayOption,
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get itemBasedOptions() {
      return {
        __fields: typesTree.PublicItemBasedOptions,
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get basicServicePrice() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get stockedFridgePackages() {
      return {
        __fields: typesTree.PackageProjection,
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get stockedFridgeServiceOptions() {
      return {
        __fields: typesTree.StockedFridgeOptions,
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get stockedFridgeServiceOptionsAmount() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get thirdPartyServiceUrl() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get contractStatus() {
      return {
        __args: {
          token: "String"
        }
      };
    },
    period: {},
    get summary() {
      return {
        __fields: typesTree.FolioSummary
      };
    },
    get items() {
      return {
        __fields: typesTree.BookingItemView
      };
    },
    get pricing() {
      return {
        __fields: typesTree.BookingRequestPrice
      };
    },
    taxesAndFees: {},
    checkInDates: {},
    checkOutDates: {},
    get detailedCheckIn() {
      return {
        __fields: typesTree.BookingCheckTime
      };
    },
    get detailedCheckOut() {
      return {
        __fields: typesTree.BookingCheckTime
      };
    },
    get checkInTiming() {
      return {
        __fields: typesTree.BookingCheckTiming
      };
    },
    get checkOutTiming() {
      return {
        __fields: typesTree.BookingCheckTiming
      };
    },
    checkInOpenHours: {},
    get serviceRequests() {
      return {
        __fields: typesTree.ServiceRequestUserView
      };
    },
    get cancelledRequestsToBeNotified() {
      return {
        __fields: typesTree.ServiceRequestUserView
      };
    },
    earlyCheckInOptions: {},
    lateCheckOutOptions: {},
    codes: {},
    entryInstructions: {},
    accessInstructions: {},
    accessVariables: {},
    marketingInfo: {},
    get mainGuestInfo() {
      return {
        __fields: typesTree.Person
      };
    },
    guestList: {},
    contracts: {},
    idVerificationState: {},
    protection: {},
    confirmationCompletedSteps: {},
    get paymentsSummaryView() {
      return {
        __fields: typesTree.PublicBookingPaymentsSummary
      };
    },
    flexibility: {},
    get listing() {
      return {
        __fields: typesTree.BookingListing
      };
    },
    get home() {
      return {
        __fields: typesTree.Home
      };
    },
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    get hotelRoomType() {
      return {
        __fields: typesTree.HotelRoom
      };
    }
  },
  Coupon: {
    get isValidFor() {
      return {
        __args: {
          checkIn: "LocalDate!",
          checkOut: "LocalDate!",
          homeId: "UUID"
        }
      };
    },
    get validForHomes() {
      return {
        __args: {
          checkIn: "LocalDate!",
          checkOut: "LocalDate!"
        }
      };
    },
    channelCancellationPolicyCategory: {}
  },
  Destination: {
    get homes() {
      return {
        __fields: typesTree.DestinationHome,
        __args: {
          limit: "Int"
        }
      };
    },
    get listings() {
      return {
        __fields: typesTree.Listing,
        __args: {
          limit: "Int"
        }
      };
    },
    get destinationListings() {
      return {
        __fields: typesTree.ListingViewResults,
        __args: {
          pagination: "PaginationInput"
        }
      };
    },
    faqImage: {},
    image: {},
    get faq() {
      return {
        __fields: typesTree.DestinationFaq
      };
    },
    get metatags() {
      return {
        __fields: typesTree.DestinationMetatags
      };
    },
    get preFilteredSearch() {
      return {
        __fields: typesTree.DestinationPreFilteredSearch
      };
    },
    get region() {
      return {
        __fields: typesTree.Region
      };
    }
  },
  DestinationHome: {
    get images() {
      return {
        __args: {
          limit: "Int"
        }
      };
    },
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    get region() {
      return {
        __fields: typesTree.Region
      };
    }
  },
  Home: {
    get calendar() {
      return {
        __fields: typesTree.HomeDateStatus,
        __args: {
          from: "LocalDate!",
          to: "LocalDate!",
          couponCode: "String"
        }
      };
    },
    get price() {
      return {
        __fields: typesTree.HomePriceView,
        __args: {
          period: "DateRangeInput!"
        }
      };
    },
    get amenities() {
      return {
        __fields: typesTree.HomeAmenity,
        __args: {
          sortByGroup: "Boolean"
        }
      };
    },
    get paginatedImages() {
      return {
        __args: {
          pagination: "PaginationInput!"
        }
      };
    },
    get book() {
      return {
        __fields: typesTree.ActiveHomeBook,
        __args: {
          kind: "BookKind!"
        }
      };
    },
    keywords: {},
    get region() {
      return {
        __fields: typesTree.Region
      };
    },
    state: {},
    get rooms() {
      return {
        __fields: typesTree.Room
      };
    },
    customFields: {},
    marketing: {},
    badges: {},
    images: {},
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    checkTime: {},
    get seo() {
      return {
        __fields: typesTree.HomeSeoFields
      };
    },
    get highlights() {
      return {
        __fields: typesTree.HomeHighlight
      };
    },
    crossReferenceZipCodes: {},
    get feedbacks() {
      return {
        __fields: typesTree.HomeFeedback
      };
    }
  },
  HomeSimilarResult: {
    get availability() {
      return {
        __fields: typesTree.HomeDateStatus,
        __args: {
          offset: "Int!"
        }
      };
    },
    get home() {
      return {
        __fields: typesTree.Home
      };
    }
  },
  Hotel: {
    get calendar() {
      return {
        __fields: typesTree.HotelRoomTypeDateStatusProjection,
        __args: {
          period: "DateRangeInput!"
        }
      };
    },
    get book() {
      return {
        __fields: typesTree.ActiveHomeBook,
        __args: {
          kind: "BookKind!"
        }
      };
    },
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    get featuredAmenities() {
      return {
        __fields: typesTree.HomeAmenity
      };
    },
    featuredItems: {},
    thumbnail: {},
    get aggregatedAmenities() {
      return {
        __fields: typesTree.HotelReferenceAmenityProjection
      };
    },
    get hotelRooms() {
      return {
        __fields: typesTree.HotelRoom
      };
    },
    get publicSpaces() {
      return {
        __fields: typesTree.HotelPublicSpace
      };
    },
    gallery: {},
    checkTime: {},
    petPolicy: {},
    badges: {},
    bedroomsVariety: {},
    get region() {
      return {
        __fields: typesTree.Region
      };
    },
    recommendationPlaces: {}
  },
  HotelRoom: {
    get calendar() {
      return {
        __fields: typesTree.HomeDateStatus,
        __args: {
          period: "DateRangeInput!"
        }
      };
    },
    get totalPreBookingPrices() {
      return {
        __fields: typesTree.HotelRoomTypePreBookingPrice,
        __args: {
          bookingPricesInput: "HotelBookingPricesInput!"
        }
      };
    },
    get units() {
      return {
        __fields: typesTree.Home
      };
    },
    get rooms() {
      return {
        __fields: typesTree.Home
      };
    },
    thumbnail: {},
    gallery: {},
    get amenities() {
      return {
        __fields: typesTree.HomeAmenity
      };
    },
    get bedrooms() {
      return {
        __fields: typesTree.Room
      };
    }
  },
  ManualBookingQueries: {
    get data() {
      return {
        __fields: typesTree.ManualBookingDataView,
        __args: {
          id: "UUID!",
          token: "String"
        }
      };
    }
  },
  PurchasePublicQueries: {
    get retrieveServiceRequest() {
      return {
        __fields: typesTree.PaymentLinkInfoView,
        __args: {
          requestId: "UUID!"
        }
      };
    },
    get retrieveServicesRequests() {
      return {
        __fields: typesTree.BatchServicePaymentView,
        __args: {
          paymentId: "String!"
        }
      };
    },
    get retrieveServicesRequestsByOneOfRequests() {
      return {
        __fields: typesTree.BatchServicePaymentView,
        __args: {
          requestId: "UUID!"
        }
      };
    },
    get retrieveBookingPayment() {
      return {
        __fields: typesTree.PaymentLinkInfoView,
        __args: {
          intentId: "String!"
        }
      };
    }
  },
  Query: {
    get isEmailAlreadyInUse() {
      return {
        __args: {
          email: "String!"
        }
      };
    },
    get isPasswordSet() {
      return {
        __args: {
          email: "String!"
        }
      };
    },
    get homesById() {
      return {
        __fields: typesTree.Home,
        __args: {
          homeIds: "[String!]!"
        }
      };
    },
    get home() {
      return {
        __fields: typesTree.Home,
        __args: {
          homeId: "UUID!"
        }
      };
    },
    get homes() {
      return {
        __fields: typesTree.HomeResultsWithSimilarHomeSimilarResult,
        __args: {
          regionIds: "[UUID!]",
          collectionIds: "[UUID!]",
          terms: "String",
          checkIn: "LocalDate",
          checkOut: "LocalDate",
          minPrice: "BigDecimal",
          maxPrice: "BigDecimal",
          minOccupancy: "Int",
          minPets: "Int",
          minBedrooms: "Int",
          minBeds: "Int",
          coordinates: "Coordinates",
          hideNonFeatured: "Boolean",
          amenityIds: "[UUID!]",
          propertyTypes: "[PropertyType!]",
          fromMarketingCampaign: "String",
          sort: "HomeQuerySorting",
          pagination: "PaginationInput"
        }
      };
    },
    get homesSearch() {
      return {
        __fields: typesTree.HomeSearchResult,
        __args: {
          regionIds: "[UUID!]",
          collectionIds: "[UUID!]",
          terms: "String",
          checkIn: "LocalDate",
          checkOut: "LocalDate",
          minPrice: "BigDecimal",
          maxPrice: "BigDecimal",
          minOccupancy: "Int",
          minPets: "Int",
          minBedrooms: "Int",
          minBeds: "Int",
          coordinates: "Coordinates",
          hideNonFeatured: "Boolean",
          amenityIds: "[UUID!]",
          propertyTypes: "[PropertyType!]",
          fromMarketingCampaign: "String",
          sort: "HomeQuerySorting",
          pagination: "PaginationInput"
        }
      };
    },
    get propertySpecificSearch() {
      return {
        __fields: typesTree.Home,
        __args: {
          term: "String!",
          regionIds: "[UUID!]"
        }
      };
    },
    get homeSearch() {
      return {
        __fields: typesTree.HomeResultsWithSimilarHomeSimilarResult,
        __args: {
          regionId: "UUID",
          regionIds: "[UUID!]",
          collectionIds: "[UUID!]",
          terms: "String",
          checkIn: "LocalDate",
          checkOut: "LocalDate",
          minPrice: "BigDecimal",
          maxPrice: "BigDecimal",
          minOccupancy: "Int",
          minPets: "Int",
          minBedrooms: "Int",
          minBeds: "Int",
          coordinates: "Coordinates",
          amenityIds: "[UUID!]",
          fromMarketingCampaign: "String",
          propertyTypes: "[PropertyType!]",
          sort: "HomeQuerySorting",
          pagination: "PaginationInput"
        }
      };
    },
    get filterableAmenities() {
      return {
        __fields: typesTree.Amenity,
        __args: {
          regionIds: "[UUID!]"
        }
      };
    },
    get filterableAmenitiesSearch() {
      return {
        __fields: typesTree.Amenity,
        __args: {
          publicRegionIds: "[UUID!]"
        }
      };
    },
    get filterableAmenitiesAreaSearch() {
      return {
        __fields: typesTree.Amenity,
        __args: {
          coordinates: "Coordinates"
        }
      };
    },
    get petFeeHomeOption() {
      return {
        __fields: typesTree.PublicItemBasedOptions,
        __args: {
          homeId: "UUID!"
        }
      };
    },
    get conciergeServices() {
      return {
        __args: {
          homeId: "UUID!"
        }
      };
    },
    get collections() {
      return {
        __fields: typesTree.Collection,
        __args: {
          isOffsite: "Boolean"
        }
      };
    },
    get collectionsSearch() {
      return {
        __fields: typesTree.Collection,
        __args: {
          term: "String",
          featured: "Boolean",
          limit: "Int!"
        }
      };
    },
    get collection() {
      return {
        __fields: typesTree.Collection,
        __args: {
          id: "UUID!"
        }
      };
    },
    get findCollection() {
      return {
        __fields: typesTree.Collection,
        __args: {
          tag: "String!"
        }
      };
    },
    get managedUnit() {
      return {
        __fields: typesTree.ManagedUnit,
        __args: {
          managedUnitId: "UUID!"
        }
      };
    },
    get neighborhoodsHomesCount() {
      return {
        __args: {
          stateCode: "String",
          city: "String"
        }
      };
    },
    get hotelRooms() {
      return {
        __fields: typesTree.HotelRoom,
        __args: {
          hotelId: "UUID!",
          checkIn: "LocalDate",
          checkOut: "LocalDate",
          minOccupancy: "Int",
          minPets: "Int"
        }
      };
    },
    get findHotel() {
      return {
        __fields: typesTree.Hotel,
        __args: {
          hotelId: "UUID",
          hotelHash: "String"
        }
      };
    },
    get states() {
      return {
        __args: {
          countryId: "String"
        }
      };
    },
    get regions() {
      return {
        __fields: typesTree.PublicRegionViewResults,
        __args: {
          featuredOnly: "Boolean",
          pagination: "PaginationInput"
        }
      };
    },
    get assets() {
      return {
        __args: {
          assetIds: "[UUID!]!"
        }
      };
    },
    get booking() {
      return {
        __fields: typesTree.Booking,
        __args: {
          bookingId: "UUID",
          bookingHash: "String",
          token: "String"
        }
      };
    },
    get bookings() {
      return {
        __fields: typesTree.Booking,
        __args: {
          bookingHash: "String"
        }
      };
    },
    get canAttachDocument() {
      return {
        __args: {
          token: "String!"
        }
      };
    },
    get requiresIdVerification() {
      return {
        __fields: typesTree.BookingIdVerification,
        __args: {
          token: "String!"
        }
      };
    },
    get postBookingRentalAgreement() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get previewAgreement() {
      return {
        __args: {
          context: "ContextPreview!"
        }
      };
    },
    get getContractMarkdown() {
      return {
        __args: {
          bookingId: "UUID!",
          token: "String"
        }
      };
    },
    get preBookingPriceBreakdown() {
      return {
        __fields: typesTree.PreBookingResponseView,
        __args: {
          bookingRequest: "BookingRequestInput!"
        }
      };
    },
    get preBookingPricesBreakdown() {
      return {
        __fields: typesTree.PreBookingPricesResponseView,
        __args: {
          bookingRequest: "BookingRequestInput!",
          clientType: "ClientTypeInput"
        }
      };
    },
    get cartPrice() {
      return {
        __fields: typesTree.BookingCartPricesResponseView,
        __args: {
          bookingRequest: "BookingRequestInput!",
          walletAmount: "BigInt",
          cartId: "UUID",
          clientType: "ClientTypeInput"
        }
      };
    },
    get hotelCartPrice() {
      return {
        __fields: typesTree.BookingCartPricesResponseView,
        __args: {
          request: "PublicHotelBookingRequest!",
          walletAmount: "BigInt",
          cartId: "UUID",
          clientType: "ClientTypeInput"
        }
      };
    },
    get cartInsuranceBreakdown() {
      return {
        __fields: typesTree.BookingCartPriceView,
        __args: {
          cartId: "UUID!",
          clientType: "ClientTypeInput"
        }
      };
    },
    get requestBookingCartBalancePayment() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get cartAvailableWalletAmount() {
      return {
        __args: {
          cartId: "UUID!"
        }
      };
    },
    get preBookingPrices() {
      return {
        __fields: typesTree.PreBookingPrice,
        __args: {
          bookingPricesRequest: "BookingPricesRequest!"
        }
      };
    },
    get totalPreBookingPrices() {
      return {
        __fields: typesTree.PreBookingPrice,
        __args: {
          bookingPricesRequest: "BookingPricesRequest!"
        }
      };
    },
    get totalMinimumHotelPreBookingPrices() {
      return {
        __fields: typesTree.HotelRoomTypePreBookingPrice,
        __args: {
          hotelsBookingPricesRequest: "HotelsBookingPricesRequest!"
        }
      };
    },
    get availableBookingPaymentCards() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get availablePaymentBanks() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get idVerificationLink() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get bookingConfirmationCompletedSteps() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get bookingMarketingInfo() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get bookingCancellationPolicy() {
      return {
        __args: {
          bookingId: "UUID!",
          token: "String"
        }
      };
    },
    get bookingCancellationPolicyTimeline() {
      return {
        __fields: typesTree.ChannelCancellationPolicyTimeline,
        __args: {
          date: "LocalDate!",
          bookingId: "UUID",
          homeId: "UUID",
          listingId: "UUID",
          checkInDate: "LocalDate",
          leadSource: "LeadSource",
          token: "String"
        }
      };
    },
    get bookingCancellationPolicyFullTimeline() {
      return {
        __fields: typesTree.ChannelCancellationPolicyTimeline,
        __args: {
          bookingId: "UUID",
          listingId: "UUID",
          checkInDate: "LocalDate",
          leadSource: "LeadSource",
          token: "String"
        }
      };
    },
    get calculateBookingRefund() {
      return {
        __fields: typesTree.RefundCalculationView,
        __args: {
          bookingId: "UUID!",
          token: "String"
        }
      };
    },
    get bookingShareLink() {
      return {
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get getBookingReceipt() {
      return {
        __fields: typesTree.PublicBookingReceipt,
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get coupon() {
      return {
        __fields: typesTree.Coupon,
        __args: {
          code: "String!"
        }
      };
    },
    get gift() {
      return {
        __args: {
          hash: "Int!"
        }
      };
    },
    get rentalizerEstimate() {
      return {
        __args: {
          address: "String!",
          bedrooms: "Int",
          bathrooms: "Int",
          accommodates: "Int"
        }
      };
    },
    get serviceOrders() {
      return {
        __fields: typesTree.ServiceOrderQueries,
        __args: {
          bookingId: "UUID!"
        }
      };
    },
    get websiteAgreement() {
      return {
        __args: {
          isWavier: "Boolean"
        }
      };
    },
    get destination() {
      return {
        __fields: typesTree.Destination,
        __args: {
          destinationId: "UUID!"
        }
      };
    },
    get vrmDestinations() {
      return {
        __fields: typesTree.VrmDestination,
        __args: {
          source: "LeadSource"
        }
      };
    },
    get vrmDestination() {
      return {
        __fields: typesTree.VrmDestination,
        __args: {
          id: "UUID!"
        }
      };
    },
    get hotelDestination() {
      return {
        __fields: typesTree.HotelDestination,
        __args: {
          id: "UUID!"
        }
      };
    },
    get listingsSearch() {
      return {
        __fields: typesTree.ListingSearchProjection,
        __args: {
          publicRegionIds: "[UUID!]",
          collectionIds: "[UUID!]",
          checkIn: "LocalDate",
          checkOut: "LocalDate",
          minOccupancy: "Int",
          minPets: "Int",
          minBedrooms: "Int",
          minBeds: "Int",
          coordinates: "ListingSearchCoordinates",
          amenityIds: "[UUID!]",
          propertyTypes: "[ListingPropertyType!]",
          sort: "ListingQuerySorting",
          pagination: "PaginationInput"
        }
      };
    },
    get listingsSearchForMap() {
      return {
        __args: {
          publicRegionIds: "[UUID!]",
          collectionIds: "[UUID!]",
          checkIn: "LocalDate",
          checkOut: "LocalDate",
          minOccupancy: "Int",
          minPets: "Int",
          minBedrooms: "Int",
          minBeds: "Int",
          coordinates: "ListingSearchCoordinates",
          strictCoordinates: "Boolean",
          amenityIds: "[UUID!]",
          propertyTypes: "[ListingPropertyType!]",
          placeInfo: "PlaceInfo"
        }
      };
    },
    get listingSpecificSearch() {
      return {
        __fields: typesTree.Listing,
        __args: {
          term: "String!"
        }
      };
    },
    get user() {
      return {
        __fields: typesTree.User
      };
    },
    communicationCategories: {},
    get hotels() {
      return {
        __fields: typesTree.Hotel
      };
    },
    countries: {},
    cities: {},
    termsAndConditions: {},
    privacyPolicy: {},
    customFields: {},
    get realEstateBrokers() {
      return {
        __fields: typesTree.RealEstateBrokerPublicView
      };
    },
    availablePaymentCards: {},
    bookingSelfCancellationReasons: {},
    get manualBooking() {
      return {
        __fields: typesTree.ManualBookingQueries
      };
    },
    get faqs() {
      return {
        __fields: typesTree.FaqCategory
      };
    },
    get purchase() {
      return {
        __fields: typesTree.PurchasePublicQueries
      };
    },
    get referralSummary() {
      return {
        __fields: typesTree.ReferralSummary
      };
    },
    get creditsHistory() {
      return {
        __fields: typesTree.WalletTransactionView
      };
    },
    get destinations() {
      return {
        __fields: typesTree.Destination
      };
    },
    get competitorsOnlyDestinations() {
      return {
        __fields: typesTree.Destination
      };
    },
    get hotelDestinations() {
      return {
        __fields: typesTree.HotelDestination
      };
    },
    get defaultRegionServices() {
      return {
        __fields: typesTree.DefaultRegionServiceView
      };
    }
  },
  ServiceOrderQueries: {
    get midStayCleaningOptions() {
      return {
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get checkTimeOptions() {
      return {
        __fields: typesTree.BookingCheckTimeOptionsNoAuthView,
        __args: {
          serviceId: "UUID!"
        }
      };
    },
    get availableServices() {
      return {
        __fields: typesTree.PubliclyAvailableService,
        __args: {
          ofKinds: "[ServiceKind!]"
        }
      };
    },
    get serviceRequests() {
      return {
        __fields: typesTree.ServiceRequestNoAuthView
      };
    }
  },
  VrmDestination: {
    get homes() {
      return {
        __fields: typesTree.DestinationHome,
        __args: {
          limit: "Int"
        }
      };
    },
    get listings() {
      return {
        __fields: typesTree.Listing,
        __args: {
          limit: "Int"
        }
      };
    },
    get destinationListings() {
      return {
        __fields: typesTree.ListingViewResults,
        __args: {
          pagination: "PaginationInput"
        }
      };
    },
    image: {},
    get metatags() {
      return {
        __fields: typesTree.DestinationMetatags
      };
    },
    get region() {
      return {
        __fields: typesTree.Region
      };
    },
    state: {},
    get support() {
      return {
        __fields: typesTree.VrmDestinationSupport
      };
    }
  },
  CartConfirmPayment: {
    bookings: {},
    booking: {},
    serviceIds: {}
  },
  ActiveHomeBook: {
    sections: {}
  },
  Address: {
    state: {},
    get region() {
      return {
        __fields: typesTree.Region
      };
    }
  },
  Amenity: {
    tags: {},
    amenityGroup: {},
    iconImage: {}
  },
  BatchServicePaymentView: {
    get booking() {
      return {
        __fields: typesTree.BookingInfo
      };
    },
    home: {},
    servicesInfo: {},
    payer: {}
  },
  BookingCartPriceView: {
    nights: {},
    longTermDiscount: {},
    preBookingTotal: {},
    get taxesAndFees() {
      return {
        __fields: typesTree.TaxesAndFeesView
      };
    },
    couponDiscount: {},
    securityDeposits: {},
    insurance: {},
    subtotal: {},
    preBookingTotalBeforeTaxes: {},
    preBookingTotalToPay: {},
    totalOfStay: {},
    totalToPay: {}
  },
  BookingCartPricesResponseView: {
    get creditCard() {
      return {
        __fields: typesTree.BookingCartPriceView
      };
    },
    get ach() {
      return {
        __fields: typesTree.BookingCartPriceView
      };
    },
    get creditCardWithInsurance() {
      return {
        __fields: typesTree.BookingCartPriceView
      };
    }
  },
  BookingCheckTime: {
    get custom() {
      return {
        __fields: typesTree.CheckTimeRequest
      };
    }
  },
  BookingCheckTimeOptionsNoAuthView: {
    options: {}
  },
  BookingCheckTiming: {
    get custom() {
      return {
        __fields: typesTree.CheckTimingRequest
      };
    }
  },
  BookingIdVerification: {
    crossReferenceZipCodes: {}
  },
  BookingInfo: {
    period: {}
  },
  BookingItemView: {
    get details() {
      return {
        __fields: typesTree.BookingServiceItemDetails
      };
    },
    discount: {},
    adjustment: {},
    refund: {},
    cancellation: {}
  },
  BookingListing: {
    get referenceHomeInfo() {
      return {
        __fields: typesTree.BookingReferenceHomeInfo
      };
    },
    get hotelRoomType() {
      return {
        __fields: typesTree.HotelRoom
      };
    },
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    get referenceHotelInfo() {
      return {
        __fields: typesTree.Hotel
      };
    }
  },
  BookingReferenceHomeInfo: {
    get region() {
      return {
        __fields: typesTree.Region
      };
    },
    get rooms() {
      return {
        __fields: typesTree.Room
      };
    },
    crossReferenceZipCodes: {}
  },
  BookingRequestPrice: {
    nights: {}
  },
  BookingServiceItemDetails: {
    dateRange: {},
    items: {}
  },
  CancellationRefundPublicView: {
    paid: {},
    nonCancellableFees: {}
  },
  ChannelCancellationPolicyTimeline: {
    get timeline() {
      return {
        __fields: typesTree.ChannelCancellationPolicyTimelineEntry
      };
    }
  },
  ChannelCancellationPolicyTimelineEntry: {
    policy: {},
    dates: {},
    get refundCalculation() {
      return {
        __fields: typesTree.CancellationRefundPublicView
      };
    }
  },
  CheckTimeRequest: {
    cost: {}
  },
  CheckTimingRequest: {
    cost: {}
  },
  Collection: {
    get homes() {
      return {
        __fields: typesTree.Home
      };
    },
    image: {}
  },
  DefaultRegionServiceView: {
    coverImage: {}
  },
  DestinationFaq: {
    icon: {}
  },
  DestinationHotelView: {
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    get collection() {
      return {
        __fields: typesTree.Collection
      };
    },
    bedroomsVariety: {},
    get hotel() {
      return {
        __fields: typesTree.Hotel
      };
    }
  },
  DestinationMetatags: {
    image: {}
  },
  DestinationPreFilteredSearch: {
    image: {}
  },
  FaqCategory: {
    get sections() {
      return {
        __fields: typesTree.FaqSection
      };
    }
  },
  FaqSection: {
    faqs: {}
  },
  FolioSummary: {
    paid: {},
    deposit: {}
  },
  FridgePackageVendorView: {
    image: {}
  },
  FridgePackageView: {
    get vendor() {
      return {
        __fields: typesTree.FridgePackageVendorView
      };
    },
    packageOrder: {},
    items: {},
    images: {}
  },
  HomeAmenity: {
    get amenity() {
      return {
        __fields: typesTree.Amenity
      };
    }
  },
  HomeDateStatus: {
    restrictions: {}
  },
  HomeFeedback: {
    bookingPeriod: {}
  },
  HomeHighlight: {
    coverImage: {}
  },
  HomePriceView: {
    nightlyPrices: {}
  },
  HomeResults: {
    paginationParams: {},
    get results() {
      return {
        __fields: typesTree.Home
      };
    }
  },
  HomeResultsWithSimilarHomeSimilarResult: {
    paginationParams: {},
    get results() {
      return {
        __fields: typesTree.Home
      };
    },
    get similarResults() {
      return {
        __fields: typesTree.HomeSimilarResult
      };
    }
  },
  HomeSearchResult: {
    get mainResults() {
      return {
        __fields: typesTree.HomeResults
      };
    },
    get similarResults() {
      return {
        __fields: typesTree.HomeSimilarResultResults
      };
    }
  },
  HomeSeoFields: {
    keywords: {}
  },
  HomeSimilarResultResults: {
    paginationParams: {},
    get results() {
      return {
        __fields: typesTree.HomeSimilarResult
      };
    }
  },
  HotelDestination: {
    get faq() {
      return {
        __fields: typesTree.DestinationFaq
      };
    },
    faqImage: {},
    image: {},
    get metatags() {
      return {
        __fields: typesTree.DestinationMetatags
      };
    },
    get preFilteredSearch() {
      return {
        __fields: typesTree.DestinationPreFilteredSearch
      };
    },
    get region() {
      return {
        __fields: typesTree.Region
      };
    },
    get hotelsInformation() {
      return {
        __fields: typesTree.DestinationHotelView
      };
    }
  },
  HotelListingDetails: {
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    bedroomsVariety: {}
  },
  HotelPublicSpace: {
    gallery: {},
    spaces: {},
    get roomAmenities() {
      return {
        __fields: typesTree.HotelPublicSpaceAmenity
      };
    },
    get amenities() {
      return {
        __fields: typesTree.HotelPublicSpaceAmenity
      };
    }
  },
  HotelPublicSpaceAmenity: {
    get amenity() {
      return {
        __fields: typesTree.Amenity
      };
    }
  },
  HotelReferenceAmenityProjection: {
    get hotelAmenity() {
      return {
        __fields: typesTree.HomeAmenity
      };
    },
    roomTypeIds: {}
  },
  HotelRoomTypeDateStatusProjection: {
    restrictions: {}
  },
  HotelRoomTypePreBookingPrice: {
    preBookingTotal: {},
    preBookingTotalPerNight: {},
    fees: {},
    warnings: {}
  },
  Listing: {
    get highlights() {
      return {
        __fields: typesTree.HomeHighlight
      };
    },
    images: {},
    marketing: {},
    get region() {
      return {
        __fields: typesTree.Region
      };
    },
    homeFields: {},
    get hotelFields() {
      return {
        __fields: typesTree.HotelListingDetails
      };
    }
  },
  ListingSearchProjection: {
    get mainResults() {
      return {
        __fields: typesTree.ListingViewResults
      };
    },
    get similarResults() {
      return {
        __fields: typesTree.ListingSimilarResultViewResults
      };
    }
  },
  ListingSimilarResult: {
    get listing() {
      return {
        __fields: typesTree.Listing
      };
    }
  },
  ListingSimilarResultViewResults: {
    paginationParams: {},
    get results() {
      return {
        __fields: typesTree.ListingSimilarResult
      };
    }
  },
  ListingViewResults: {
    paginationParams: {},
    get results() {
      return {
        __fields: typesTree.Listing
      };
    }
  },
  ManagedUnit: {
    get address() {
      return {
        __fields: typesTree.Address
      };
    },
    get listing() {
      return {
        __fields: typesTree.Home
      };
    }
  },
  ManualBookingDataView: {
    get guestAddress() {
      return {
        __fields: typesTree.Address
      };
    },
    get preBookingPriceBreakdown() {
      return {
        __fields: typesTree.PreBookingResponseView
      };
    }
  },
  PackageProjection: {
    fridgePackage: {},
    get vendor() {
      return {
        __fields: typesTree.PackageVendorProjection
      };
    },
    items: {},
    images: {}
  },
  PackageProjectionWithQuantity: {
    get projection() {
      return {
        __fields: typesTree.PackageProjection
      };
    },
    packageOrder: {}
  },
  PackageVendorProjection: {
    image: {}
  },
  PaymentLinkInfoView: {
    get booking() {
      return {
        __fields: typesTree.BookingInfo
      };
    },
    home: {},
    payer: {},
    get service() {
      return {
        __fields: typesTree.ServiceRequestUserView
      };
    }
  },
  PaymentSourceView: {
    linkTargets: {},
    bankName: {}
  },
  Person: {
    emails: {},
    phones: {},
    get address() {
      return {
        __fields: typesTree.Address
      };
    }
  },
  PoolHeatingFullStayOption: {
    period: {}
  },
  PreBookingPrice: {
    preBookingTotal: {},
    preBookingTotalPerNight: {},
    fees: {}
  },
  PreBookingPricesResponseView: {
    get creditCard() {
      return {
        __fields: typesTree.PreBookingResponseView
      };
    },
    get ach() {
      return {
        __fields: typesTree.PreBookingResponseView
      };
    },
    get creditCardWithInsurance() {
      return {
        __fields: typesTree.PreBookingResponseView
      };
    },
    insurance: {}
  },
  PreBookingResponseView: {
    nights: {},
    longTermDiscount: {},
    preBookingTotal: {},
    get taxesAndFees() {
      return {
        __fields: typesTree.TaxesAndFeesView
      };
    },
    couponDiscount: {},
    securityDeposits: {},
    subtotal: {},
    preBookingTotalBeforeTaxes: {},
    preBookingTotalToPay: {},
    totalOfStay: {},
    totalToPay: {}
  },
  PublicBookingPaymentsSummary: {
    get payments() {
      return {
        __fields: typesTree.PublicBookingPaymentsViewPayment
      };
    },
    get refunds() {
      return {
        __fields: typesTree.PublicBookingPaymentsViewRefund
      };
    },
    creditsRefunds: {}
  },
  PublicBookingPaymentsViewPayment: {
    get source() {
      return {
        __fields: typesTree.PaymentSourceView
      };
    }
  },
  PublicBookingPaymentsViewRefund: {
    get source() {
      return {
        __fields: typesTree.PaymentSourceView
      };
    }
  },
  PublicBookingReceipt: {
    nights: {},
    taxesAndFees: {},
    get services() {
      return {
        __fields: typesTree.PublicBookingReceiptService
      };
    },
    get adjustments() {
      return {
        __fields: typesTree.PublicBookingReceiptAdjustment
      };
    },
    deposits: {},
    get summary() {
      return {
        __fields: typesTree.FolioSummary
      };
    },
    get payments() {
      return {
        __fields: typesTree.PublicBookingReceiptViewPaid
      };
    },
    discounts: {}
  },
  PublicBookingReceiptAdjustment: {
    adjustment: {}
  },
  PublicBookingReceiptService: {
    get details() {
      return {
        __fields: typesTree.BookingServiceItemDetails
      };
    },
    adjustment: {}
  },
  PublicBookingReceiptViewPaid: {
    get source() {
      return {
        __fields: typesTree.PaymentSourceView
      };
    }
  },
  PublicItemBasedOptions: {
    options: {}
  },
  PublicRegionViewResults: {
    paginationParams: {},
    get results() {
      return {
        __fields: typesTree.Region
      };
    }
  },
  PubliclyAvailableService: {
    duration: {},
    priceRange: {},
    images: {},
    constraints: {}
  },
  RealEstateBrokerPublicView: {
    state: {},
    image: {}
  },
  ReferralSummary: {
    successful: {},
    signedUp: {},
    pending: {}
  },
  RefundCalculationView: {
    policy: {},
    paid: {}
  },
  Region: {
    regionIds: {},
    state: {},
    coordinates: {},
    businessEntity: {}
  },
  Room: {
    get sleepingPlaces() {
      return {
        __fields: typesTree.RoomAmenity
      };
    },
    get roomAmenities() {
      return {
        __fields: typesTree.RoomAmenity
      };
    },
    get bathroomAmenities() {
      return {
        __fields: typesTree.RoomAmenity
      };
    },
    thumbnail: {},
    images: {}
  },
  RoomAmenity: {
    agencies: {}
  },
  ServiceRequestData: {
    dates: {},
    get fridgePackages() {
      return {
        __fields: typesTree.FridgePackageView
      };
    },
    get packages() {
      return {
        __fields: typesTree.PackageProjectionWithQuantity
      };
    }
  },
  ServiceRequestDataNoAuthView: {
    dates: {},
    get fridgePackages() {
      return {
        __fields: typesTree.FridgePackageView
      };
    }
  },
  ServiceRequestNoAuthView: {
    get data() {
      return {
        __fields: typesTree.ServiceRequestDataNoAuthView
      };
    },
    image: {}
  },
  ServiceRequestUserRefundView: {
    card: {}
  },
  ServiceRequestUserView: {
    get data() {
      return {
        __fields: typesTree.ServiceRequestData
      };
    },
    image: {},
    get refund() {
      return {
        __fields: typesTree.ServiceRequestUserRefundView
      };
    }
  },
  StockedFridgeOptions: {
    get packages() {
      return {
        __fields: typesTree.StockedFridgePackageOption
      };
    }
  },
  StockedFridgePackageOption: {
    get vendor() {
      return {
        __fields: typesTree.FridgePackageVendorView
      };
    },
    items: {},
    images: {}
  },
  TaxesAndFeesView: {
    taxes: {},
    fees: {},
    services: {},
    insurance: {},
    petFeeGroup: {},
    items: {}
  },
  TransactionOperators: {
    requestOperator: {},
    editingOperator: {}
  },
  User: {
    get person() {
      return {
        __fields: typesTree.Person
      };
    },
    optouts: {}
  },
  VrmDestinationSupport: {
    directorPhoto: {}
  },
  WalletTransaction: {
    metadata: {}
  },
  WalletTransactionView: {
    get transaction() {
      return {
        __fields: typesTree.WalletTransaction
      };
    },
    get operators() {
      return {
        __fields: typesTree.TransactionOperators
      };
    },
    get booking() {
      return {
        __fields: typesTree.Booking
      };
    }
  }
};
let verbose = false;
let headers = {};
let url = "https://arriere.prod.avantstay.com/public/graphql";
let retryConfig = {
  max: 0,
  before: void 0,
  waitBeforeRetry: 0
};
let responseListeners = [];
let errorsParser = void 0;
let apiEndpoint = (0, import_endpoint.getApiEndpointCreator)({
  getClient: () => ({ url, headers, retryConfig }),
  responseListeners,
  maxAge: 3e4,
  verbose,
  typesTree,
  formatGraphQL,
  errorsParser
});
const arrierePublic = {
  addResponseListener: (listener) => responseListeners.push(listener),
  setHeader: (key, value) => {
    headers[key] = value;
  },
  setHeaders: (newHeaders) => {
    headers = newHeaders;
  },
  setRetryConfig: (options) => {
    if (!Number.isInteger(options.max) || options.max < 0) {
      throw new Error("retryOptions.max should be a non-negative integer");
    }
    retryConfig = {
      max: options.max,
      waitBeforeRetry: options.waitBeforeRetry,
      before: options.before
    };
  },
  setUrl: (_url) => url = _url,
  queries: {
    user: apiEndpoint("query", "user"),
    communicationCategories: apiEndpoint("query", "communicationCategories"),
    isEmailAlreadyInUse: apiEndpoint("query", "isEmailAlreadyInUse"),
    isPasswordSet: apiEndpoint("query", "isPasswordSet"),
    homesById: apiEndpoint("query", "homesById"),
    home: apiEndpoint("query", "home"),
    homes: apiEndpoint("query", "homes"),
    homesSearch: apiEndpoint("query", "homesSearch"),
    propertySpecificSearch: apiEndpoint("query", "propertySpecificSearch"),
    homeSearch: apiEndpoint("query", "homeSearch"),
    filterableAmenities: apiEndpoint("query", "filterableAmenities"),
    filterableAmenitiesSearch: apiEndpoint("query", "filterableAmenitiesSearch"),
    filterableAmenitiesAreaSearch: apiEndpoint("query", "filterableAmenitiesAreaSearch"),
    petFeeHomeOption: apiEndpoint("query", "petFeeHomeOption"),
    conciergeServices: apiEndpoint("query", "conciergeServices"),
    collections: apiEndpoint("query", "collections"),
    collectionsSearch: apiEndpoint("query", "collectionsSearch"),
    collection: apiEndpoint("query", "collection"),
    findCollection: apiEndpoint("query", "findCollection"),
    managedUnit: apiEndpoint("query", "managedUnit"),
    neighborhoodsHomesCount: apiEndpoint("query", "neighborhoodsHomesCount"),
    hotelRooms: apiEndpoint("query", "hotelRooms"),
    findHotel: apiEndpoint("query", "findHotel"),
    hotels: apiEndpoint("query", "hotels"),
    countries: apiEndpoint("query", "countries"),
    states: apiEndpoint("query", "states"),
    cities: apiEndpoint("query", "cities"),
    regions: apiEndpoint("query", "regions"),
    siteTermsAndConditions: apiEndpoint("query", "siteTermsAndConditions"),
    siteFairHousingPolicy: apiEndpoint("query", "siteFairHousingPolicy"),
    siteTermsAndConditionsReferral: apiEndpoint("query", "siteTermsAndConditionsReferral"),
    termsAndConditions: apiEndpoint("query", "termsAndConditions"),
    privacyPolicy: apiEndpoint("query", "privacyPolicy"),
    customFields: apiEndpoint("query", "customFields"),
    assets: apiEndpoint("query", "assets"),
    realEstateBrokers: apiEndpoint("query", "realEstateBrokers"),
    booking: apiEndpoint("query", "booking"),
    bookings: apiEndpoint("query", "bookings"),
    canAttachDocument: apiEndpoint("query", "canAttachDocument"),
    requiresIdVerification: apiEndpoint("query", "requiresIdVerification"),
    postBookingRentalAgreement: apiEndpoint("query", "postBookingRentalAgreement"),
    previewAgreement: apiEndpoint("query", "previewAgreement"),
    getContractMarkdown: apiEndpoint("query", "getContractMarkdown"),
    preBookingPriceBreakdown: apiEndpoint("query", "preBookingPriceBreakdown"),
    preBookingPricesBreakdown: apiEndpoint("query", "preBookingPricesBreakdown"),
    cartPrice: apiEndpoint("query", "cartPrice"),
    hotelCartPrice: apiEndpoint("query", "hotelCartPrice"),
    cartInsuranceBreakdown: apiEndpoint("query", "cartInsuranceBreakdown"),
    requestBookingCartBalancePayment: apiEndpoint("query", "requestBookingCartBalancePayment"),
    cartAvailableWalletAmount: apiEndpoint("query", "cartAvailableWalletAmount"),
    preBookingPrices: apiEndpoint("query", "preBookingPrices"),
    totalPreBookingPrices: apiEndpoint("query", "totalPreBookingPrices"),
    totalMinimumHotelPreBookingPrices: apiEndpoint("query", "totalMinimumHotelPreBookingPrices"),
    availablePaymentCards: apiEndpoint("query", "availablePaymentCards"),
    availableBookingPaymentCards: apiEndpoint("query", "availableBookingPaymentCards"),
    availablePaymentBanks: apiEndpoint("query", "availablePaymentBanks"),
    idVerificationLink: apiEndpoint("query", "idVerificationLink"),
    bookingConfirmationCompletedSteps: apiEndpoint("query", "bookingConfirmationCompletedSteps"),
    bookingMarketingInfo: apiEndpoint("query", "bookingMarketingInfo"),
    bookingCancellationPolicy: apiEndpoint("query", "bookingCancellationPolicy"),
    bookingCancellationPolicyTimeline: apiEndpoint("query", "bookingCancellationPolicyTimeline"),
    bookingCancellationPolicyFullTimeline: apiEndpoint("query", "bookingCancellationPolicyFullTimeline"),
    calculateBookingRefund: apiEndpoint("query", "calculateBookingRefund"),
    bookingSelfCancellationReasons: apiEndpoint("query", "bookingSelfCancellationReasons"),
    bookingShareLink: apiEndpoint("query", "bookingShareLink"),
    getBookingReceipt: apiEndpoint("query", "getBookingReceipt"),
    manualBooking: apiEndpoint("query", "manualBooking"),
    faqs: apiEndpoint("query", "faqs"),
    coupon: apiEndpoint("query", "coupon"),
    purchase: apiEndpoint("query", "purchase"),
    getInvitationToken: apiEndpoint("query", "getInvitationToken"),
    getInvitationLink: apiEndpoint("query", "getInvitationLink"),
    gift: apiEndpoint("query", "gift"),
    referralSummary: apiEndpoint("query", "referralSummary"),
    walletBalance: apiEndpoint("query", "walletBalance"),
    creditsHistory: apiEndpoint("query", "creditsHistory"),
    spentCredits: apiEndpoint("query", "spentCredits"),
    vaykMd: apiEndpoint("query", "vaykMd"),
    rentalizerEstimate: apiEndpoint("query", "rentalizerEstimate"),
    serviceOrders: apiEndpoint("query", "serviceOrders"),
    websiteAgreement: apiEndpoint("query", "websiteAgreement"),
    destination: apiEndpoint("query", "destination"),
    destinations: apiEndpoint("query", "destinations"),
    competitorsOnlyDestinations: apiEndpoint("query", "competitorsOnlyDestinations"),
    vrmDestinations: apiEndpoint("query", "vrmDestinations"),
    vrmDestination: apiEndpoint("query", "vrmDestination"),
    hotelDestinations: apiEndpoint("query", "hotelDestinations"),
    hotelDestination: apiEndpoint("query", "hotelDestination"),
    listingsSearch: apiEndpoint("query", "listingsSearch"),
    listingsSearchForMap: apiEndpoint("query", "listingsSearchForMap"),
    listingSpecificSearch: apiEndpoint("query", "listingSpecificSearch"),
    defaultRegionServices: apiEndpoint("query", "defaultRegionServices")
  },
  mutations: {
    isEmailAlreadyInUse: apiEndpoint("mutation", "isEmailAlreadyInUse"),
    createGuestWithPhone: apiEndpoint("mutation", "createGuestWithPhone"),
    createGuest: apiEndpoint("mutation", "createGuest"),
    createGuestFromInvite: apiEndpoint("mutation", "createGuestFromInvite"),
    createGuestFromReferral: apiEndpoint("mutation", "createGuestFromReferral"),
    updateGuest: apiEndpoint("mutation", "updateGuest"),
    changeGuestPhone: apiEndpoint("mutation", "changeGuestPhone"),
    confirmEmail: apiEndpoint("mutation", "confirmEmail"),
    resendVerificationEmail: apiEndpoint("mutation", "resendVerificationEmail"),
    updatePassword: apiEndpoint("mutation", "updatePassword"),
    login: apiEndpoint("mutation", "login"),
    refreshToken: apiEndpoint("mutation", "refreshToken"),
    validatePhone: apiEndpoint("mutation", "validatePhone"),
    createNewUser: apiEndpoint("mutation", "createNewUser"),
    createNewUserWithPassword: apiEndpoint("mutation", "createNewUserWithPassword"),
    sendSmsVerificationCode: apiEndpoint("mutation", "sendSmsVerificationCode"),
    requestPhoneVerificationCode: apiEndpoint("mutation", "requestPhoneVerificationCode"),
    requestPhoneVerificationCodeSecure: apiEndpoint("mutation", "requestPhoneVerificationCodeSecure"),
    resendPhoneVerificationCodeSecure: apiEndpoint("mutation", "resendPhoneVerificationCodeSecure"),
    requestMagicLink: apiEndpoint("mutation", "requestMagicLink"),
    verifyMagicLink: apiEndpoint("mutation", "verifyMagicLink"),
    verifyPhoneVerificationCode: apiEndpoint("mutation", "verifyPhoneVerificationCode"),
    requestPasswordReset: apiEndpoint("mutation", "requestPasswordReset"),
    resetPassword: apiEndpoint("mutation", "resetPassword"),
    addPushToken: apiEndpoint("mutation", "addPushToken"),
    kustomerHash: apiEndpoint("mutation", "kustomerHash"),
    zendeskHash: apiEndpoint("mutation", "zendeskHash"),
    conciergeFormProps: apiEndpoint("mutation", "conciergeFormProps"),
    updateOptout: apiEndpoint("mutation", "updateOptout"),
    subscribeToMailingListV2: apiEndpoint("mutation", "subscribeToMailingListV2"),
    subscribeOwnerToMailingList: apiEndpoint("mutation", "subscribeOwnerToMailingList"),
    setPasswordIfNotExists: apiEndpoint("mutation", "setPasswordIfNotExists"),
    generateAssetUploadUrl: apiEndpoint("mutation", "generateAssetUploadUrl"),
    booking: apiEndpoint("mutation", "booking"),
    requestBookingPayment: apiEndpoint("mutation", "requestBookingPayment"),
    requestBookingPaymentUsingCard: apiEndpoint("mutation", "requestBookingPaymentUsingCard"),
    requestBookingPaymentWithAffirm: apiEndpoint("mutation", "requestBookingPaymentWithAffirm"),
    requestBookingPaymentWithACH: apiEndpoint("mutation", "requestBookingPaymentWithACH"),
    requestBookingPaymentWithWallet: apiEndpoint("mutation", "requestBookingPaymentWithWallet"),
    requestBookingPaymentUsingCardWithWallet: apiEndpoint("mutation", "requestBookingPaymentUsingCardWithWallet"),
    initializeCartPayment: apiEndpoint("mutation", "initializeCartPayment"),
    updateCartPaymentPrice: apiEndpoint("mutation", "updateCartPaymentPrice"),
    setCartPayment: apiEndpoint("mutation", "setCartPayment"),
    confirmCartPayment: apiEndpoint("mutation", "confirmCartPayment"),
    confirmBookingPayment: apiEndpoint("mutation", "confirmBookingPayment"),
    attachDocument: apiEndpoint("mutation", "attachDocument"),
    selfBookingCancellation: apiEndpoint("mutation", "selfBookingCancellation"),
    addMyBookingGuest: apiEndpoint("mutation", "addMyBookingGuest"),
    requestServices: apiEndpoint("mutation", "requestServices"),
    requestServicesOrder: apiEndpoint("mutation", "requestServicesOrder"),
    requestEarlyCheckIn: apiEndpoint("mutation", "requestEarlyCheckIn"),
    requestEarlyCheckInWithBookingCard: apiEndpoint("mutation", "requestEarlyCheckInWithBookingCard"),
    requestLateCheckOut: apiEndpoint("mutation", "requestLateCheckOut"),
    requestLateCheckOutWithBookingCard: apiEndpoint("mutation", "requestLateCheckOutWithBookingCard"),
    requestCheckTime: apiEndpoint("mutation", "requestCheckTime"),
    requestPoolHeating: apiEndpoint("mutation", "requestPoolHeating"),
    requestPoolHeatingRemainingStay: apiEndpoint("mutation", "requestPoolHeatingRemainingStay"),
    requestStockedFridge: apiEndpoint("mutation", "requestStockedFridge"),
    requestCustomStockedFridgeService: apiEndpoint("mutation", "requestCustomStockedFridgeService"),
    requestStockedFridgeService: apiEndpoint("mutation", "requestStockedFridgeService"),
    requestMidStayClean: apiEndpoint("mutation", "requestMidStayClean"),
    createLiveAgreement: apiEndpoint("mutation", "createLiveAgreement"),
    requestItemBasedService: apiEndpoint("mutation", "requestItemBasedService"),
    requestBasicService: apiEndpoint("mutation", "requestBasicService"),
    bookingGuests: apiEndpoint("mutation", "bookingGuests"),
    uploadMarketingInfo: apiEndpoint("mutation", "uploadMarketingInfo"),
    updateMarketingGuests: apiEndpoint("mutation", "updateMarketingGuests"),
    addBookingConfirmationCompletedStep: apiEndpoint("mutation", "addBookingConfirmationCompletedStep"),
    requestConciergeServices: apiEndpoint("mutation", "requestConciergeServices"),
    signContract: apiEndpoint("mutation", "signContract"),
    registerBookingOwner: apiEndpoint("mutation", "registerBookingOwner"),
    requestContact: apiEndpoint("mutation", "requestContact"),
    eventEmailContact: apiEndpoint("mutation", "eventEmailContact"),
    buyerContact: apiEndpoint("mutation", "buyerContact"),
    sellerContact: apiEndpoint("mutation", "sellerContact"),
    agentContact: apiEndpoint("mutation", "agentContact"),
    brokerContact: apiEndpoint("mutation", "brokerContact"),
    requestPartnership: apiEndpoint("mutation", "requestPartnership"),
    requestRetreatProposal: apiEndpoint("mutation", "requestRetreatProposal"),
    newAgentLead: apiEndpoint("mutation", "newAgentLead"),
    newBuyerLeadStep1: apiEndpoint("mutation", "newBuyerLeadStep1"),
    newBuyerLeadStep2: apiEndpoint("mutation", "newBuyerLeadStep2"),
    newSellerLead: apiEndpoint("mutation", "newSellerLead"),
    createDocument: apiEndpoint("mutation", "createDocument"),
    trackEvent: apiEndpoint("mutation", "trackEvent"),
    generateTrackedUrl: apiEndpoint("mutation", "generateTrackedUrl"),
    calculateYourRevenue: apiEndpoint("mutation", "calculateYourRevenue"),
    salesLeadStep: apiEndpoint("mutation", "salesLeadStep"),
    purchase: apiEndpoint("mutation", "purchase"),
    sendEmailInvitation: apiEndpoint("mutation", "sendEmailInvitation"),
    sendEmailInvitationByHash: apiEndpoint("mutation", "sendEmailInvitationByHash"),
    createInvitationHash: apiEndpoint("mutation", "createInvitationHash"),
    applyForDigitalDuos: apiEndpoint("mutation", "applyForDigitalDuos"),
    submitEstimates: apiEndpoint("mutation", "submitEstimates"),
    submitVRM: apiEndpoint("mutation", "submitVRM"),
    submitSellerLead: apiEndpoint("mutation", "submitSellerLead"),
    submitBuyerLead: apiEndpoint("mutation", "submitBuyerLead"),
    submitAgentLead: apiEndpoint("mutation", "submitAgentLead")
  }
};
var stdin_default = arrierePublic;
